// ─────────────────────────────────────────────
//  DraftRow + FlagBadge — the editable review-table row for AssignmentImport.
//  Extracted from AssignmentImport.js to keep that file under the 500-line cap.
// ─────────────────────────────────────────────
import React from "react";
import st from "./assignmentImportStyles";

// ── Flag badge ────────────────────────────────
export function FlagBadge({ reason }) {
  const labels = {
    unmatched: "Unmatched code",
    nullField: "Blank / unreadable",
    emptyStaffing: "No CRNA assigned",
    unmatchedCrnaName: "CRNA not on roster",
    unmatchedSurgeonCode: "Surgeon not matched",
    unknownAttendingCode: "MD code not matched",
  };
  return (
    <span style={st.flagBadge} title={labels[reason] || reason}>
      {labels[reason] || reason}
    </span>
  );
}

// ── Draft row in the review table ────────────
export default function DraftRow({ row, index, onChange }) {
  const hasFlags = row.flags && row.flags.length > 0;
  return (
    <tr style={hasFlags ? st.flaggedRow : undefined}>
      <td style={st.td}>
        <input
          aria-label={`Room for row ${index + 1}`}
          style={st.cell}
          value={row.orRoom || ""}
          onChange={(e) => onChange(index, "orRoom", e.target.value)}
        />
      </td>
      <td style={st.td}>
        <input
          aria-label={`Start time for row ${index + 1}`}
          style={st.cell}
          value={row.startTime || ""}
          onChange={(e) => onChange(index, "startTime", e.target.value)}
        />
        {row.flags?.filter((f) => f.field === "startTime").map((f, i) => (
          <FlagBadge key={i} reason={f.reason} />
        ))}
      </td>
      <td style={st.td}>
        <span style={st.attendingCell}>
          <input
            aria-label={`Attending for row ${index + 1}`}
            style={st.cell}
            value={row.attendingName || ""}
            onChange={(e) => onChange(index, "attendingName", e.target.value)}
          />
          {row.flags?.filter((f) => f.field === "attendingShortCode" || f.field === "attending").map((f, i) => (
            <FlagBadge key={i} reason={f.reason} />
          ))}
        </span>
        {row.callOrder != null && (
          <span style={st.callOrderBadge} title="Call order">#{row.callOrder}</span>
        )}
        {row.isAIC && <span style={st.aicBadge}>AIC</span>}
      </td>
      <td style={st.td}>
        <input
          aria-label={`CRNA for row ${index + 1}`}
          style={st.cell}
          value={row.ahpName || ""}
          onChange={(e) => onChange(index, "ahpName", e.target.value)}
        />
        {row.flags?.filter((f) => f.field === "ahpId" || f.field === "staffing").map((f, i) => (
          <FlagBadge key={i} reason={f.reason} />
        ))}
      </td>
      <td style={st.td}>
        <input
          aria-label={`Shift code for row ${index + 1}`}
          style={{ ...st.cell, width: 60 }}
          value={row.ahpShiftCode || ""}
          onChange={(e) => onChange(index, "ahpShiftCode", e.target.value)}
        />
      </td>
    </tr>
  );
}
